import * as React from "react";

// import { useStaticQuery, graphql } from "gatsby";
// import Img from "gatsby-image";

const HeroBan = ({ children, image, color, className }) => {
  // const data = useStaticQuery(graphql`
  //   query Images {
  //     image: file(relativePath: { eq: "HeroBanners/Shower.png" }) {
  //       id
  //       childImageSharp {
  //         fluid {
  //           ...GatsbyImageSharpFluid
  //         }
  //       }
  //     }
  //   }
  // `);
  return (
    <div
      className="overflow-hidden"
      style={{ backgroundColor: `${color}`, color: `${color}` }}
    >
      <div className="grid grid-cols-1 lg:grid-cols-10 items-center">
        <div className="lg:ml-20 lg:col-start-1 lg:col-end-5 2xl:ml-0 2xl:col-start-2 2xl:col-end-5 mt-0 mx-auto w-full z-50">
          <div className="hero-content md:w-3/4 md:mx-auto my-10 lg:w-full lg:mx-0 mx-7">
            {children}
          </div>
        </div>
        {/* <Img
          className="w-full lg:col-start-5 lg:col-end-11"
          // src={image}
          // alt=""
          fluid={data.image.childImageSharp.fluid}
        ></Img> */}
        <img
          className="w-full lg:col-start-5 lg:col-end-11"
          src={image}
          alt=""
        ></img>
      </div>
    </div>
  );
};

export default HeroBan;
